import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import Price from '../Price/Price';
import {BasketTotalStyled, MessageRow, PriceRow, Total} from './BasketTotal.style';

export class BasketTotal extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <BasketTotalStyled
        onClick={this.props.onTotalClick}
        data-rw="menu-page--basket--total"
        isExpanded={this.props.isExpanded}
      >
        <PriceRow>
          <Total><FormattedMessage id="basket.total" /></Total>
          <Price
            amount={this.props.total}
          />
        </PriceRow>
        {
          this.props.showDeliveryMinimumMessage &&
          <MessageRow>
            <FormattedMessage
              id="checkout.deliveryMinimumAmountErrorLine1"
              values={{
                price: <Price amount={this.props.minimumAmount - this.props.total} />,
                minimumAmount: <Price amount={this.props.minimumAmount} />
              }}
            />
          </MessageRow>
        }
      </BasketTotalStyled>
    );
  }
}

BasketTotal.propTypes = {
  total: PropTypes.number.isRequired,
  onTotalClick: PropTypes.func,
  showDeliveryMinimumMessage: PropTypes.bool,
  minimumAmount: PropTypes.number,
  isExpanded: PropTypes.bool
};

export default BasketTotal;



// WEBPACK FOOTER //
// ./components/BasketBar/BasketTotal.js